import { render, staticRenderFns } from "./berthInvestmentManageDetail.vue?vue&type=template&id=5141643e&scoped=true&"
import script from "./berthInvestmentManageDetail.vue?vue&type=script&lang=js&"
export * from "./berthInvestmentManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./berthInvestmentManageDetail.vue?vue&type=style&index=0&id=5141643e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141643e",
  null
  
)

export default component.exports